import { Component } from "react";
import { GetQuery, langCheck } from "Pub/js/utils";
import { getMultiLangValue, getCurrentLangText, getLanguageMetas } from "Pub/js/getMulti";
import QuickLaunchModal from "Pages/NewHome/AppGroup/QuickLaunchModal";
import WidgetJSLoader from "Pages/NewHome/CreaterForWidget/WidgetJSLoader";
import { WidgetSidePath } from "Pub/js/constant";
import DragDropItem from "Components/DragDropItem";
import { getRelateidObj, getSpecialColor } from "Pages/NewHome/utilService";
import platform from "Pub/js/platform";
const { toast } = platform;
const { NCSidebox, NCMultiLangText, NCRadio, NCInputNumber, NCPopconfirm, NCButton } = platform.base;
const { NCRadioGroup } = NCRadio;
const DefaultSideData = { // 默认值
    cardArrangement: {
        type: 'autoFixedWidth',
        value: {
            setCol: 2
        }
    },
    cardList: []
}

export default class QuickLaunchSide extends Component {
    constructor(props) {
        super(props);
        const urlParams = GetQuery(window.location.hash);
        this.languageMetas = getLanguageMetas();
        this.state = {
            quickLaunchSideData: { ...DefaultSideData, ...props.sideData },
            cardModalShow: false, // 新增or编辑卡片弹窗
            relateidObj: getRelateidObj(
                urlParams.pk_responsibility,
                urlParams.is_group,
                urlParams.workbenchid
            ),
            widgetSide: null
        }
    }

    componentDidMount() {
        WidgetJSLoader(WidgetSidePath, key => {
            const widgetSide = window[key].default;
            if (widgetSide) {
                this.setState({
                    widgetSide
                });
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        const { sideData } = nextProps;
        const newSideData = { ...DefaultSideData, ...sideData };
        const { quickLaunchSideData } = this.state;
        if (!_.isEqual(newSideData, quickLaunchSideData)) {
            this.setState({
                quickLaunchSideData: newSideData
            })
        }
    }

    // 获取名称多语值
    getNameValue() {
        const { quickLaunchSideData } = this.state;
        return getMultiLangValue('name', quickLaunchSideData);
    }

    // 数据改变
    handleChange(value, key) {
        const { quickLaunchSideData } = this.state;
        const { onChange } = this.props;
        quickLaunchSideData[key] = value;
        this.setState(quickLaunchSideData);
        onChange(quickLaunchSideData);
    }

    // 新增卡片
    addCard() {
        this.setState({
            cardModalShow: true
        })
    }

    // 弹窗新增卡片回调
    updateApps(dataList) {
        const { quickLaunchSideData } = this.state;
        const { onChange } = this.props;
        const updatedData = {
            ...quickLaunchSideData,
            cardList: dataList
        }
        this.setState({
            quickLaunchSideData: updatedData
        })
        onChange(updatedData);
    }

    // 删除卡片
    deleteCard(index) {
        const { quickLaunchSideData } = this.state;
        const { onChange } = this.props;
        const updatedData = { ...quickLaunchSideData };
        updatedData.cardList.splice(index, 1);
        this.setState({
            quickLaunchSideData: updatedData
        })
        onChange(updatedData);
        toast({ content: langCheck('0000PUB-000406' /* 删除成功 */) });
    }

    // 编辑卡片
    handleEdit(index) {
        const { quickLaunchSideData } = this.state;
        this.currentHandleItem = quickLaunchSideData.cardList[index]; // 记录当前操作的，编辑的时候需要带出来,保持引用关系，编辑的时候直接改
        this.setState({
            cardModalShow: true
        })
    }

    // 处理拖拽排序
    handleDragDropChange({ dragItem, dropItem }) {
        const { onChange } = this.props;
        const { quickLaunchSideData } = this.state;
        const updatedData = { ...quickLaunchSideData };
        const { cardList } = updatedData;
        const dragIndex = dragItem.index;
        const dropIndex = dropItem.index;
        const dragedItem = cardList.splice(dragIndex, 1)[0];
        cardList.splice(dropIndex, 0, dragedItem);
        this.setState({
            quickLaunchSideData: updatedData
        })
        onChange(updatedData);
    }

    render() {
        const { onClose, onChange, themeColor, editEntry } = this.props;
        const { quickLaunchSideData, cardModalShow, relateidObj } = this.state;
        const { cardList } = quickLaunchSideData;
        const { widgetSide: WidgetSide } = this.state;
        return typeof WidgetSide === 'function'
            ?
            <WidgetSide
                maskClose={onClose}
                onClose={onClose}
                widgetProps={this.props}
            >
                <div className={`common-widget-side quick-launch-side ${editEntry.isWorkbench ? 'in-designer' : ''}`}>
                    {/* 组件名称 不要了，公共配置已包含 */}
                    {/* <div className="side-item">
                    <span className="item-label">{ langCheck('0000PUB-000509') }</span>
                    <div className="item-content">
                        <NCMultiLangText value={this.getNameValue()} attrcode='name' languageMeta={this.languageMetas} onChange={(val) => {
                            quickLaunchSideData.name = val;
                            onChange(quickLaunchSideData);
                        }}></NCMultiLangText>
                    </div>
                </div> */}
                    <div className="side-item">
                        <span className="item-label">
                            {langCheck('0000PUB-000510' /* 卡片列表 */)}
                            {
                                <div className="card-add" onClick={() => { this.addCard() }}>
                                    <i className="iconfont icon-ncc-sq"></i>
                                    <span>{langCheck('0000PUB-000435' /* 新增 */)}</span>
                                </div>
                            }
                        </span>
                        {
                            cardList.length
                                ?
                                <div className={`item-content card-list ${cardList.length > 6 ? 'scroll-y' : ''}`}>
                                    {
                                        cardList.map((card, index) => <DragDropItem
                                            item={{ ...card, index }}
                                            onDragDropChange={this.handleDragDropChange.bind(this)}
                                        >
                                            <div className="card-item">
                                                <i className="iconfont icon-tuozhuai1 icon-drag"></i>
                                                <div className="card-item-main" style={{
                                                    background: getSpecialColor(card.bgcolor, themeColor)
                                                }}>
                                                    <img className="icon" src={card.icon}></img>
                                                    <span className="title">{getCurrentLangText('title', card)}</span>
                                                </div>
                                                <div className="operation">
                                                    <i className="iconfont icon-yibiaopan-xiugai opr-icon" onClick={() => { this.handleEdit(index) }}></i>
                                                    <NCPopconfirm
                                                        trigger="click"
                                                        placement="left"
                                                        content={langCheck('0000PUB-000006' /* 确定要删除吗? */)}
                                                        onClose={() => { this.deleteCard(index) }}
                                                    >
                                                        <i className="iconfont icon-shanchu5 opr-icon opr-delete"></i>
                                                    </NCPopconfirm>
                                                </div>
                                            </div>
                                        </DragDropItem>)
                                    }
                                </div>
                                :
                                null
                        }
                    </div>
                    <div className="side-item">
                        <span className="item-label">{langCheck('0000PUB-000511' /* 卡片排列方式 */)}</span>
                        <div className="item-content">
                            <NCRadioGroup
                                selectedValue={quickLaunchSideData.cardArrangement.type}
                                name='cardArrangement'
                                onChange={(val) => {
                                    const { cardArrangement } = quickLaunchSideData;
                                    this.handleChange({
                                        ...cardArrangement,
                                        type: val
                                    }, 'cardArrangement')
                                }}
                            >
                                <NCRadio fieldid='quick-launch-auto-fixed' value='autoFixedWidth'>{langCheck('0000PUB-000411' /* 自适应 */)}</NCRadio>
                                <div className="set-col">
                                    <NCRadio fieldid='quick-launch-set-col' className='set-col-label' value='setCol'>{langCheck('0000PUB-000513' /* 设置列 */)}</NCRadio>
                                    <NCInputNumber
                                        className="set-col-inputnumber"
                                        value={quickLaunchSideData.cardArrangement.value['setCol']}
                                        min={1}
                                        max={12}
                                        step={1}
                                        onChange={(val) => {
                                            const { cardArrangement } = quickLaunchSideData;
                                            cardArrangement.value.setCol = val;
                                            onChange(quickLaunchSideData);
                                        }}
                                    />
                                </div>
                            </NCRadioGroup>
                        </div>
                    </div>
                    {
                        editEntry.isWorkbench && <div className="side-item-publish">
                            <NCButton fieldid="quick-launch-publish" colors="primary" onClick={() => { this.props.onPublishWidget() }}>{langCheck('0000PUB-000569') /* 发布部件 */}</NCButton>
                        </div>
                    }

                    {
                        cardModalShow && <QuickLaunchModal
                            title={getCurrentLangText('name', quickLaunchSideData)}
                            defaultData={cardList}
                            onOk={this.updateApps.bind(this)}
                            onCancel={() => {
                                this.setState({
                                    cardModalShow: false
                                })
                                if (this.currentHandleItem) { // 关闭弹窗清除当前操作数据
                                    this.currentHandleItem = null;
                                }
                            }}
                            currentData={this.currentHandleItem}
                            relateidObj={relateidObj}
                        />
                    }
                </div>
            </WidgetSide>
            :
            null
    }
}